import React, { useState } from "react";
import "../App.css";
import { Modal, Button, Box, Typography } from "@mui/material";
import MyEmail from "./Email.js";

function MyModal() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="modalDiv">
      <Button
        variant="outlined"
        size="Large"
        className="contactbtn"
        onClick={handleOpen}
      >
        Contact
      </Button>
      <Modal
        className="modal"
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box 
        className="modalBox"
        sx={{ backgroundColor: "white", padding: "2rem" }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
           
          </Typography>
          <MyEmail />
        </Box>
      </Modal>
    </div>
  );
}

export default MyModal;
